import { ReactNode } from 'react'
import { HeaderTh, TableBody } from './typography'
import { BodyTd } from './typography'

export default function FinalizedReportQpdTable({
  items,
  label,
  columnNames
}: {
  items: { key: string; label: ReactNode; value: number | string }[]
  label: ReactNode
  columnNames: [string, string]
}) {
  return (
    <>
      <p className="mb-2">- {label}</p>
      <table className="w-full">
        <thead>
          <tr>
            <HeaderTh>{columnNames[0]}</HeaderTh>
            <HeaderTh isNumeric>{columnNames[1]}</HeaderTh>
          </tr>
        </thead>
        <TableBody>
          {items.map(param => (
            <tr key={param.key}>
              <BodyTd>{param.label}</BodyTd>
              <BodyTd isNumeric>
                {typeof param.value === 'number' ? `${param.value}%` : param.value}
              </BodyTd>
            </tr>
          ))}
        </TableBody>
      </table>
    </>
  )
}
